import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=0ccdec0c&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=0ccdec0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdec0c",
  null
  
)

export default component.exports